const LogoutCircle01Icon = /*#__PURE__*/ [
  ["path", { d: "M18.5 4.40041C16.752 2.9039 14.4815 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C14.4815 22 16.752 21.0961 18.5 19.5996", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 8C18 8 22 10.946 22 12C22 13.0541 18 16 18 16M21.5 12H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { LogoutCircle01Icon as default };
//# sourceMappingURL=LogoutCircle01Icon.js.map
